const formatClid = function (val) {
  if (!val) return null
  const parts = val.split('|')
  if (parts.length < 2) return val
  return `${parts[0]} (${parts[1]})`
}

export default formatClid
